import { Routes } from '@angular/router';
import { GestionTemplatesComponent } from './pages/gestion-templates/gestion-templates.component';

export const EDITION_ROUTES: Routes = [
    {
        path: '',
        data: {
            role: 'ORGANISME',
            domaines: ['VIN'],
            menu: { icon: 'copy', libelle: 'menu.edition' }
        },
        children: [
            {
                path: '',
                redirectTo: 'gestion-templates',
                pathMatch: 'full'
            },
            {
                path: 'gestion-templates',
                component: GestionTemplatesComponent,
                data: { menu: { libelle: 'Gestion des templates' } }
            }
        ]
    }
];
